import React, { useRef } from 'react';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import ProductsButton from '@src/components/ui-kit/buttons/ProductsButton';
import { openNewTab } from 'util/helpers';
import styles from './arena-section.module.css';

export default function ArenaSection() {
  const video = useRef<HTMLVideoElement | null>(null);

  return (
    <div className={styles.root} data-cy='arena-section'>
      <span className={styles.unitedSectionsTitle}>GAMING – THE ARENA</span>
      <div className={styles.sectionContent}>
        <div className={styles.gifWpapper}>
          <video
            ref={video}
            preload='metadata'
            src={`${WEBSITE_PUBLIC_CDN}/arena-section-video-wbm.webm`}
            muted
            loop
            playsInline
            autoPlay={true}
            className={styles.gif}
            onLoadedMetadata={() => video.current && video.current.play()}
          ></video>
        </div>
        <div className={styles.textWrapper}>
          <span className={styles.textBlockTitle}>
            A Persistent, Expanding Open-World RPG
          </span>
          <div className={styles.parWrapper}>
            <p className={styles.defaultText}>
              Our Web based expanding open world game showcases our
              groundbreaking live services and proprietary cloud gaming servers
              designed for the new era of gaming.{' '}
              <span className={styles.grayText}>
                Built entirely on OZONE's tech. This
              </span>{' '}
              web-based RPG-fighter hybrid{' '}
              <span className={styles.grayText}>is where</span> players,
              creators, and communities collide.
            </p>
          </div>
          <div className={styles.buttonWrapper}>
            <ProductsButton
              onClick={() => openNewTab('https://arena.ozonemetaverse.io/game')}
            >
              DISCOVER THE ARENA
            </ProductsButton>
          </div>
        </div>
      </div>
    </div>
  );
}
